<template>
  <div
    v-if="loading"
    id="page"
    class="flex flex-col items-center justify-center min-h-screen w-full"
  >
    <div
      class="spinner mx-auto"
    ></div>
    <div class="p-4" style="color: rgb(78 143 243);">
      Loading, please wait...
    </div>
  </div>
  <div v-else class="overflow-x-hidden">
    <BaseModal
      :showModal="showDeleteModal"
      v-on:close="showDeleteModal = false"
      v-on:confirm="
        deleteSurvey(idToDelete);
        showDeleteModal = false;
      "
    >
      <template v-slot:body>
          <p class="text-sm text-gray-500">
            <strong>
              Warning: you will lose any existing responses you have received
              for this survey.
            </strong>
            <br />

            Are you sure you want to delete this survey and lose existing
            responses? This action cannot be undone.
          </p>
      </template>
    </BaseModal>

    <div class="">
      <header-notification></header-notification>

        <Navbar
          id="header"
          class="bg-white border-b border-solid border-gray-200 opacity-100 py-2 px-10 shadow"
        >
        </Navbar>

      <h1 class="mx-32 mt-10 text-xl text-purple-700 font-bold"> Welcome to Appflowz 👍</h1> 

      <h1 class="mx-32 mt-3"> To get started quickly, try out a template: </h1> 

      <template-carousel class="mt-5" ></template-carousel>

      <hr class="mt-5" />

      <div class="flex flex-wrap -mx-2 mt-20 px-10">

        <div v-for="(survey, index) in surveys" :key="index" class="w-72 px-2" style="min-height:245px">
          <survey-card
            :survey="survey"
            v-on:confirm-delete="confirmDelete"
            v-on:clone-survey="cloneSurvey"
          ></survey-card>
        </div>
        <div class="w-72 px-2">
          <div
            class="bg-purple-100 rounded-lg shadow hover:shadow-lg cursor-pointer mb-6 px-5 py-16"
            @click="newSurvey()"
          >
            <div class="text-gray-600 text-lg font-bold text-center">
              Create a new flow
            </div>

            <svg-icon
              icon="heroicons/solid/plus-circle"
              class="mx-auto mt-2 text-xs font-semibold flex w-10 h-10 p-0 rounded-full items-center justify-center leading-tight relative text-purple-700"
            />
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Survey from "@/models/Survey";
import Navbar from "@/components/Header.vue";
//import Sidebar from "@/components/CreativeTim/Sidebar.vue";
import HeaderNotification from "@/components/HeaderNotification.vue";
import SurveyCard from "@/components/SurveyCard.vue";
import router from "@/router/route.js";
import TemplateCarousel from '@/components/TemplateCarousel.vue';
//import TemplateChooser from '@/components/TemplateChooser.vue';

//import axios from "axios";
export default {
  components: {
    Navbar,
    //Sidebar,
    HeaderNotification,
    SurveyCard,
    TemplateCarousel,
    //TemplateChooser
  },
  data() {
    return {
      //surveys: [{}],
      loading: false,
      showDeleteModal: false,
      idToDelete: null,
    };
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
    surveys() {
      return Survey.query()
        .where("user_id", this.user.id)
        .withAllRecursive()
        .get();
    },
  },
  methods: {
    async init() {
      this.devlog('starting init')
      this.loading = true;
      //get all surveys for logged in user
      var result = await Survey.api().get("/api/survey/user/" + this.user.id, {
        dataKey: "data",
      });
      this.devlog('backend loading finished')
      this.loading = false;

      if (result.response.status != 200) {
        this.$store.dispatch("notification/add", {
          message: "An error occured loading surveys",
        });
      }

    },
    async newSurvey(template=null) {
      let surveyData = template ?? Survey.sampleSurvey(this.user.id);

      //Add new survey to app state; returns survey model ONLY w/o steps or options
      var surveyModel = await Survey.insertNew({ data: surveyData });

      //Get the full nested survey object
      var survey = Survey.query()
        .whereId(surveyModel.id)
        .with("steps", (query) => {
          query
            .orderBy("order", "asc")
            .with("options", (query) => {
              query.orderBy("order", "asc").with("contents", (query) => {
                query.orderBy("order", "asc");
              });
            })
            .with("rows", (query) => {
              query.orderBy("order", "asc").with("columns", (query) => {
                query.orderBy("order", "asc").with("contents", (query) => {
                  query.orderBy("order", "asc");
                });
              });
            });
        })
        .first();

      //Save full survey to backend database
      var result = await Survey.api().post("/api/survey/save", survey);

      if (result.response.status == 200) {
        //Launch survey buider with new survey
        router.push({ path: `/builder/${survey.id}` }); // -> /user/123
      } else {
        this.$store.dispatch("notification/add", {
          message: "An error occured: " + result.response.data.error.message,
        });
      }
    },
    async cloneSurvey(id) {
      //Get full survey plus related entities from server (bc only the survey model is retrieved on original page load)
      var result = await Survey.api().get("/api/survey/" + id, {
        dataKey: "data",
      });

      if (result.response.status == 200) {
        //Query selected survey from state.entities
        let oldSurvey = Survey.query()
          .whereId(id)
          .withAllRecursive()
          .first();

        //Clone to new survey
        let newSurvey = Survey.clone(oldSurvey);

        //Save new survey to backend API
        var postResult = await Survey.api().post("/api/survey/save", newSurvey);

        if (postResult.response.status == 200) {
          //If saved, add survey to app state
          Survey.insert({ data: newSurvey });
        } else {
          this.$store.dispatch("notification/add", {
            message: "An error occured saving survey.",
          });
        }
      } else {
        this.$store.dispatch("notification/add", {
          message: "An error occured finding survey.",
        });
      }
    },
    confirmDelete(id) {
      this.showDeleteModal = true;
      this.idToDelete = id;
    },
    async deleteSurvey(id) {
      var result = await Survey.api().delete("/api/survey/delete/" + id);
      if (result.response.status == 200) {
        Survey.delete(id);

        this.$store.dispatch("notification/add", {
          message: "Survey deleted.",
        });
      } else {
        this.$store.dispatch("notification/add", {
          message: "An error occured loading surveys",
        });
      }
    },
  },
  created() {

    this.init();
  },
  watch: {
    $route(to, from) {
      this.init();
    },
  },
};
</script>

<style></style>
